import { ADD_WHITELISTED_CREATORS_ON_SUCCESS } from 'root/src/client/logic/tableItem/actionIds'

export default payload => ({
	type: ADD_WHITELISTED_CREATORS_ON_SUCCESS,
	payload,
})
